var _excluded = ["className", "children", "control", "error"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormSemantic } from 'semantic-ui-react';
import { Checkbox, Radio, Label } from "../..";
import * as SUI from "../../utils/SUI";

/**
 * A field is a form element containing a label and an input.
 *
 * @param {any} props
 * @returns
 * @see Form
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Radio
 * @see Select
 * @see Visibility
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FormField = function FormField(props) {
  var className = props.className,
    children = props.children,
    control = props.control,
    error = props.error,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var errorPointing = _.get(error, 'pointing', 'above');
  var errorLabel = Label.create(error, {
    autoGenerateKey: false,
    defaultProps: {
      prompt: true,
      pointing: errorPointing
    }
  });
  var errorLabelBefore = (errorPointing === 'below' || errorPointing === 'right') && errorLabel;
  var errorLabelAfter = (errorPointing === 'above' || errorPointing === 'left') && errorLabel;
  if (!_.isNil(children) || !_.isEmpty(children)) {
    return /*#__PURE__*/_jsx(FormSemantic.Field, Object.assign({}, rest, {
      children: children
    }));
  }
  if (!_.isNil(control)) {
    if (control === Checkbox || control === Radio) {
      return /*#__PURE__*/_jsxs(FormSemantic.Field, {
        className: className,
        children: [errorLabelBefore, /*#__PURE__*/React.createElement(control, rest), errorLabelAfter]
      });
    }
    return /*#__PURE__*/_jsx(FormSemantic.Field, Object.assign({
      control: control
    }, rest));
  }
  return /*#__PURE__*/_jsx(FormSemantic.Field, Object.assign({}, rest));
};
FormField.handledProps = ["as", "children", "className", "content", "control", "disabled", "error", "inline", "label", "required", "type", "width"];
FormField.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** Primary content. */
  children: PropTypes.node,
  /** Additional classes. */
  className: PropTypes.string,
  /** Shorthand for primary content. */
  content: PropTypes.node,
  /**
     * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
     * Extra FormField props are passed to the control component.
     * Mutually exclusive with children.
     */
  control: PropTypes.oneOfType([PropTypes.func, PropTypes.oneOf(['button', 'input', 'select', 'textarea'])]),
  /** Individual fields may be disabled. */
  disabled: PropTypes.bool,
  /** Individual fields may display an error state. */
  error: PropTypes.bool,
  /** A field can have its label next to instead of above it. */
  inline: PropTypes.bool,
  // Heads Up!
  // Do not disallow children with `label` shorthand
  // The `control` might accept a `label` prop and `children`
  /** Mutually exclusive with children. */
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  /** A field can show that input is mandatory. */
  required: PropTypes.bool,
  /** Passed to the control component (i.e. <input type='password' />) */
  type: PropTypes.string,
  /** A field can specify its width in grid columns */
  width: PropTypes.oneOf(SUI.WIDTHS)
};
export default FormField;